module.exports = __webpack_public_path__ + "static/media/certificate.d89d5d84.svg";